class CustomSelect extends HTMLElement {
    constructor() {
        super();
        this.options = [];
        this.selectedOption = null;
        this.isDisabled = false;

        this.addEventListener('click', this.toggleShowList);
        window.addEventListener('click', (event) => this.hideList(this, event));
    }

    setDisabled() {
        this.isDisabled = true;
        this.classList.add('disabled');
    }

    toggleShowList() {
        if (!this.isDisabled) {
            const select = this.querySelector('.br_select') ?? null;
            if (select) {
                select.classList.toggle('open');
            }

            this.dispatchEvent(
                new CustomEvent('toggleSelect', {
                    bubbles: true,
                    composed: true,
                    detail: { status: 'open' },
                }),
            );
        }
    }

    hideList(component, event) {
        const select = component.querySelector('.br_select') ?? null;
        if (select && !select.contains(event.target)) {
            select.classList.remove('open');

            this.dispatchEvent(
                new CustomEvent('toggleSelect', {
                    bubbles: true,
                    composed: true,
                    detail: { status: 'close' },
                }),
            );
        }
    }

    selectItem(element) {
        const id = element.getAttribute('data-value');
        const foundOption = this.options.find((option) => option.id == id);
        if (foundOption) {
            this.selectedOption = {
                id: id,
                value: element.innerText,
            };
            if (!element.classList.contains('selected')) {
                if (element.parentNode.querySelector('.br_custom-option.selected')) {
                    element.parentNode.querySelector('.br_custom-option.selected').classList.remove('selected');
                }
                element.classList.add('selected');
                element.closest('.br_select').querySelector('.br_select__trigger span').innerText = foundOption.value;
            }
            this.dispatchEvent(
                new CustomEvent('selectedOption', {
                    bubbles: true,
                    composed: true,
                    detail: { id: id },
                }),
            );
        }
    }

    addElementToList(elements, isFirstDefault = false) {
        this.options = [...this.options, ...elements];
        const customOptionsContainer = this.querySelector('.br_custom-options') ?? null;
        const select = this;
        if (customOptionsContainer) {
            elements.forEach((item, index) => {
                if (isFirstDefault && index == 0) {
                    this.selectedOption = item;
                    const defaultContent = this.querySelector('.br_select__trigger span') ?? null;
                    if (defaultContent) {
                        defaultContent.innerHTML = item.value;
                    }
                }
                if (location.pathname.includes('/search') && item.id == 'art-name') {
                    this.selectedOption = item;
                    const defaultContent = this.querySelector('.br_select__trigger span') ?? null;
                    if (defaultContent) {
                        defaultContent.innerHTML = item.value;
                    }
                }
                const spanElement = document.createElement('span');
                spanElement.setAttribute('class', `br_custom-option ${index == 0 && isFirstDefault ? 'selected' : ''}`);
                spanElement.setAttribute('data-value', item.id);
                spanElement.innerText = item.value;
                spanElement.addEventListener('click', () => select.selectItem(spanElement));
                customOptionsContainer.appendChild(spanElement);
            });
        }
    }
}
if (!window.customElements.get('custom-select')) {
    window.customElements.define('custom-select', CustomSelect);
}
